<template>
  <div class="HomePage">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <van-sticky>
      <NavBar />
      <div class="keyword-strip">
        <div class="location-btn">
          <van-icon name="location-o" size="26" color="#ffffff" />
        </div>
        <div class="keyword-input">
          <van-icon name="search" size="24" color="#666" @click="handleSearch" />
          <input
            v-model.trim="queryForm.search_mobile"
            type="text"
            placeholder="Search services or businesses"
            @keyup.enter="handleSearch"
          />
        </div>
      </div>
      <div class="filter-bar">
        <van-dropdown-menu active-color="#1E3C3E">
          <van-dropdown-item v-model="queryForm.category_id" :title="industryTitle" @change="handleChange" :options="industryOption"/>
          <van-dropdown-item v-model="queryForm.sort" :title="orderTitle" @change="handleOrderChange" :options="orderOption"/>
        </van-dropdown-menu>
      </div>
    </van-sticky>
    <div class="list">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="No more"
            @load="onLoad">
            <div v-for="item in homeData" class="shop-item" :key="item.shop_supplier_id">
              <div class="introduce"  @click="handleShop(item)" >
                <img :src="getUrl(item.logo && item.logo.file_path)" alt="">
                <div class="comments">
                  <div>{{item.score}}</div>
                  <div>{{item.score_count}} reviews</div>
                </div>
              </div>
              <div class="shopInfo">
                <div class="infoItem">
                  <div class="infoName" @click="handleShop(item)">{{ item.name }}</div>
                  <div class="address">{{ item.address }}</div>
                </div>
                <div class="infoItem" style="text-align:center">
                  <img src="@/assets/home/address.png" alt="">
                  <div>{{ item.distance_show || '0km' }}</div>
                </div>
              </div>
              <HomeCard :bgColor="'#fff'" :list="item.showservice" />
            </div>
        </van-list>
        <van-empty v-if="homeData.length == 0" description="No matching data found" />
    </div>
  </div>
</template>
<script>
import myMixin from '@/utils/myMixin';
import { ensureUserLngLat } from '@/utils/location'
import { Toast } from 'vant';
import NavBar from '@/components/NavBar/index.vue'
import HomeCard from '@/components/Home/HomeCard.vue'
export default {
  name: 'loginPage',
  mixins: [myMixin],
  data(){
    return {
      industryTitle:'Industry',
      orderTitle:'Default',
      queryForm:{
        category_id:null,
        sort:'',
        app_id:10001,
        search:'',
        search_mobile:'',
        page:1,
        list_rows:10
      },
      industryOption: [],
      orderOption: [
        { text: 'Default', value: '' },
        { text: 'Sort by Distance', value: 'distance_show' },
        { text: 'Sort by Rating', value: 'score' },
      ],
      list:[],
      loading:false,
      finished:false,
      homeData:[
      ]
    }
  },
  components: {
    NavBar,
    HomeCard
  },
  mounted(){
    this.getCategoryList()
    this.getSupplierList()
  },
  methods:{
    async getSupplierList(){
      try{
        // Best-effort: cache user's lng/lat before requesting supplier list.
        await ensureUserLngLat().catch(() => {})
        // sort 必传：默认传空字符串即可
        const res = await this.$api.getSupplierList({ ...this.queryForm })
        if(res && res.code == 1){
          this.homeData = (res.data && res.data.list && res.data.list.data) ? res.data.list.data : []
        }else{
          Toast.fail((res && res.msg) ? res.msg : 'Failed to load store list')
        }
      }catch(e){
        Toast.fail('Failed to load store list')
      }
    },
    async getCategoryList(){
      const result = await this.$api.getCategoryList({app_id:10001})
      if(result.code == 1 ){
        const list = result.data.list
        for(let i in list ){
          this.industryOption.push({text:list[i].name,value:list[i].category_id})
        }
      }else{
        Toast.fail(result.msg)
      }
    },
    // 改变Industry
    handleChange(value){
      let index = this.industryOption.findIndex(item=>{
        return item.value == value
      })
      if( index != -1 ){
        this.industryTitle = this.industryOption[index].text
      }
      this.queryForm.page = 1
      this.getSupplierList()
    },
    // 改变排序
    handleOrderChange(value){
      let index = this.orderOption.findIndex(item=>{
        return item.value == value
      })
      if( index != -1 ){
        this.orderTitle = this.orderOption[index].text
      }
      this.queryForm.page = 1
      this.getSupplierList()
    },
    // 搜索
    handleSearch(){
      this.queryForm.page = 1
      this.getSupplierList()
    },
      // 异步更新数据
    // setTimeout 仅做示例，真实场景中一般为 ajax 请求
    onLoad(){
      for (let i = 0; i < 10; i++) {
        this.list.push(this.list.length + 1);
      }
      // 加载状态结束
      this.loading = false
    },
    handleShop(item){
      // this.$api.
      this.$router.push({path:'shop',query:{shop_supplier_id:item.shop_supplier_id,app_id:this.queryForm.app_id}})
    }
  }
}
</script>
<style lang="scss" scoped>
    ::v-deep  .el-input__inner{
        background-color: #EEEEEE;
        border-color: #EEEEEE;
        color: #666666;
    }
    ::v-deep .van-dropdown-menu{
      flex: 1;
    }
    ::v-deep .van-dropdown-menu__bar{
      box-shadow: unset;
      background: transparent;
      height: auto;
      display: flex;
      gap: 8px;
    }
    ::v-deep .van-dropdown-menu__item{
      flex: 1;
      background: #F5F5F5;
      margin-right: 0;
      border-radius: 4px;
      height: 32px;
      line-height: 32px;
      justify-content: flex-start !important;
    }
    ::v-deep .van-dropdown-menu__title{
      padding: 0 12px;
      justify-content: flex-start !important;
      position: relative;
      width: 100%;
      box-sizing: border-box;
      padding-right: 24px;
      &::after{
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%) rotate(0deg);
        border-width: 5px;
        margin-top: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid #666;
        border-bottom: none;
      }
    }
    ::v-deep .van-dropdown-menu__title--down::after{
      transform: translateY(-50%) rotate(180deg);
    }
    ::v-deep .van-ellipsis{
      color: #666666;
      overflow: visible;
      text-overflow: unset;
      white-space: nowrap;
      font-size: 13px;
    }
  .HomePage{
    width: 100%;
    height: 100%;
    background: #F4F4F4;
    .sticky{
      position: -webkit-sticky; /* Safari 兼容 */
      position: sticky;
      top: 0;
    }
    .filter-bar{
      display: flex;
      align-items: center;
      padding: 10px 16px;
      background: #fff;
      gap: 8px;
    }
    .keyword-strip{
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 8px 16px 10px;
      margin-top: -1px;
      border-top: 1px solid #1A3232;
      background: #1A3232;
      .location-btn{
        width: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .keyword-input{
        flex: 1;
        height: 35px;
        background: #ebebeb;
        border-radius: 10px;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 0 14px;
        box-sizing: border-box;
        input{
          flex: 1;
          border: none;
          outline: none;
          background: transparent;
          color: #444;
          font-size: 18px;
        }
        input::placeholder{
          color: #7d7d7d;
        }
      }
    }
    .selectGroup{
        width: 100%;
        padding:0 1rem 1rem 1rem;
        display: flex;
        background-color: #fff;
        box-sizing: border-box;
        gap: 0.5rem;
    }
    .list{
        width: 100%;
        box-sizing: border-box;
        padding: 1rem;
        background-color: #F4F4F4;
        .shop-item{
          // Add spacing between shops so the last service card doesn't visually "stick" to the next shop.
          margin-bottom: 12px;
        }
        .shop-item:last-child{
          margin-bottom: 0;
        }
        .shopInfo{
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #E8F5EF;
          padding: .75rem 1rem;
          margin-bottom: 1rem;
          .infoItem{
            .infoName{
              font-size: 1.0625rem;
              font-weight: 700;
              color: #1a1a1a;
              cursor: pointer;
            }
            .address{
              font-size: .75rem;
              color: #999;
              margin-top: .25rem;
            }
            font-size: .75rem;
            img{
              width: 2.125rem;
              height: 2.125rem;
            }
          }
        }
        .introduce{
          width: 100%;
          height: 10rem;
          overflow: hidden;
          position: relative;
          background: #fff;
          img{
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
          }
          .comments{
            position: absolute;
            bottom: 1rem;
            right: 1rem;
            background: rgba(0, 0, 0, 0.20);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #fff;
            padding: .5rem;
            box-sizing: border-box;
            border-radius: .25rem;
          }
        }
    }
  }
</style>
